export default "__VITE_ASSET__DBW7sdJs__"